(function () {
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_term', 'utm_content'];

  var params = new URLSearchParams(window.location.search);
  var incoming = /** @type {Record<string, string>} */ ({});
  UTM_KEYS.forEach(function (key) {
    var val = params.get(key);
    if (val) incoming[key] = val;
  });

  if (Object.keys(incoming).length === 0) return;

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var existing = /** @type {Record<string, string>} */ (cart.attributes || {});
      var updates = /** @type {Record<string, string>} */ ({});

      UTM_KEYS.forEach(function (key) {
        if (incoming[key] && !existing[key]) {
          updates[key] = incoming[key];
        }
      });

      if (!existing['landing_url']) {
        updates['landing_url'] = window.location.href;
      }

      if (Object.keys(updates).length === 0) return;

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: updates }),
      });
    })
    .catch(function () {});
})();
